export const loadBingAds = () => {
  window.uetq = window.uetq || []
  window.uetq.push('consent', 'default', {
    ad_storage: 'denied',
  })
}
